import api from '@/apis/di/invoiceFormNumberAPI';
import crudBaseCache from '../crudBaseCache';
var crud = new crudBaseCache('invoiceFormNumber', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_invoice_form_number',
    field: {
      key: 'invoice_form_number_id',
      code: 'invoice_form_number_code',
      name: 'invoice_form_number_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
